(function () {
  if (window.__fctAutoplay) return;
  window.__fctAutoplay = true;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var DELAY = 4000;
  var PAUSE = 6000;
  var DURATION = 700;

  function slide(track, target) {
    var start = track.scrollLeft;
    var dist = target - start;
    var t0 = null;
    track.style.scrollSnapType = 'none';
    function frame(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / DURATION);
      var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      track.scrollLeft = start + dist * e;
      if (p < 1) {
        window.requestAnimationFrame(frame);
      } else {
        track.style.scrollSnapType = '';
      }
    }
    window.requestAnimationFrame(frame);
  }

  function nextTab(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.fct__tab'));
    if (tabs.length < 2) return false;
    var current = 0;
    tabs.forEach(function (tab, i) {
      if (tab.classList.contains('is-active')) current = i;
    });
    var next = (current + 1) % tabs.length;
    tabs[next].click();
    var panel = root.querySelector('.fct__panel:not([hidden])');
    var track = panel && panel.querySelector('.fct__track');
    if (track) track.scrollLeft = 0;
    return true;
  }

  function init(root) {
    if (root.__fctAuto) return;
    root.__fctAuto = true;
    var seen = true;
    var last = 0;

    if ('IntersectionObserver' in window) {
      seen = false;
      new IntersectionObserver(function (entries) {
        seen = entries[0].isIntersecting;
      }, { threshold: 0.1 }).observe(root);
    }

    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (type) {
      root.addEventListener(type, function () { last = Date.now(); }, { passive: true });
    });

    setInterval(function () {
      if (!seen || document.hidden || Date.now() - last < PAUSE) return;
      var panel = root.querySelector('.fct__panel:not([hidden])');
      if (!panel) return;
      var track = panel.querySelector('.fct__track');
      if (!track) return;
      var max = track.scrollWidth - track.clientWidth;
      var atEnd = max <= 1 || track.scrollLeft >= max - 2;
      if (atEnd) {
        if (!nextTab(root) && max > 1) slide(track, 0);
        return;
      }
      var item = track.querySelector('.fct__item');
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      var step = item ? item.getBoundingClientRect().width + gap : track.clientWidth;
      var target = Math.min(max, (Math.round(track.scrollLeft / step) + 1) * step);
      slide(track, target);
    }, DELAY);
  }

  function run() {
    document.querySelectorAll('featured-collection-tabs').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
